import { render, staticRenderFns } from "./Thrillingly.vue?vue&type=template&id=5a49289c&scoped=true"
import script from "./Thrillingly.vue?vue&type=script&lang=js"
export * from "./Thrillingly.vue?vue&type=script&lang=js"
import style0 from "./Thrillingly.vue?vue&type=style&index=0&id=5a49289c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49289c",
  null
  
)

export default component.exports